<template>
  <div class="user-list">
    <el-tabs v-model="searchParam.status" type="card" @tab-click="getList">
      <el-tab-pane label="上架" name="2"></el-tab-pane>
      <el-tab-pane label="下架" name="1"></el-tab-pane>
    </el-tabs>
    <div class="search-bar flex">
      <div class="left">
        <el-select v-model="searchParam.teacher_uuid" placeholder="授课老师" clearable @clear="getList">
          <el-option v-for="item in teacherList" :key="item.uuid" :label="item.name" :value="item.uuid"> </el-option>
        </el-select>
        <el-input v-model="searchParam.keyword_search" placeholder="输入标题" clearable @clear="getList"></el-input>
        <el-button type="primary" @click="getList('clear')">查询</el-button>
      </div>
      <div class="right">
        <a
          v-if="isteacher"
          href="https://gymoo-project-cdn.oss-cn-shenzhen.aliyuncs.com/train_service/app_upload/3eeba5c1e03c791c673f0043aea5d78e.xlsx"
          type="primary"
          target="_blank"
          >导入模板下载</a
        >
        <el-button v-if="isteacher" @click="toDetail()">新增课程</el-button>
      </div>
    </div>
    <div class="table">
      <el-table v-loading="loading" :data="tableData" border style="width: 100%">
        <el-table-column prop="course_id" label="id" fixed="left" width="120px"> </el-table-column>
        <el-table-column prop="title" label="课程名称" width="120px"> </el-table-column>
        <el-table-column prop="cover" label="封面" width="120px">
          <template slot-scope="scope">
            <el-image
              style="width: 100px; height: 100px"
              :src="scope.row.cover"
              fit="contain"
              :preview-src-list="[scope.row.cover]"
            >
            </el-image> </template
        ></el-table-column>
        <el-table-column prop="count_section" label="课节" width="120px"> </el-table-column>
        <el-table-column prop="course_teacher" label="授课老师" width="120px"> </el-table-column>
        <el-table-column prop="course_duty" label="责任老师" width="120px"> </el-table-column>

        <el-table-column prop="price" label="现价"> </el-table-column>
        <el-table-column prop="original_price" label="原价"> </el-table-column>
        <el-table-column prop="sales" label="销量"> </el-table-column>

        <el-table-column prop="create_time" label="创建时间" width="160"> </el-table-column>
        <el-table-column label="操作" fixed="right" width="350">
          <template slot-scope="scope">
            <input v-show="false" v-if="!uping" id="fileup" type="file" name="" value="" @change="getFile" />
            <el-button v-if="isteacher" class="mid-blue" @click="clickInp(scope.row)">批量导入</el-button>
            <el-button v-if="isteacher" class="mid-blue" @click="toDetail(scope.row)">查看详情</el-button>
            <el-button class="mid-blue" @click="setTop(scope.row)">推荐</el-button>
            <el-button class="mid-blue" @click="xiajia(scope.row)">{{
              scope.row.status == 2 ? "下架" : "上架"
            }}</el-button>
            <el-button v-if="isteacher" class="mid-red" @click="deleteItem(scope.row)">删除</el-button>
            <br />
            <el-button v-if="isteacher" class="mid-blue" @click="toStu(scope.row)">查看学员</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination
          :current-page="page_index"
          :page-sizes="[10, 20, 60, 100]"
          :page-size="page_size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { getTeacherList } from "@/api/teacher.js";
import { getCouseList, couseStatus, couseTop, delCouse, CourseOrderImport } from "@/api/edu.js";
import { mixin } from "@/mixins/pagination.js";

// import operations from "@/mixins/operations";
import Utils from "@/jslibs/utils";
export default {
  mixins: [mixin],
  data() {
    return {
      loading: false,
      teacherList: [],
      searchParam: {
        keyword_search: "",
        status: "2",
        start_time: "",
        end_time: "",
      },
      tableData: [],
      uping: false,
      uuid: "",
    };
  },
  computed: {
    isteacher() {
      const g = Utils.getCookie("X-Access-Group");
      return g != 927 && g != 952;
    },
    // hasAdd() {
    //     return this.operations.includes("添加课程");
    // },
    // hasEdit() {
    //     return this.operations.includes("编辑课程");
    // },
    // hasDelete() {
    //     return this.operations.includes("删除课程");
    // }
  },
  mounted() {
    this.getList();
    this.getTeacher("");
  },
  methods: {
    clickInp(e) {
      console.log(e);
      this.uuid = e.uuid;
      document.getElementById("fileup").click();
    },
    getFile(e) {
      console.log(e.target.files[0]);
      const self = this;
      if (e && e.target.files) {
        const fd = new FormData();
        fd.append("file", e.target.files[0]);
        fd.append("uuid", this.uuid);
        // console.log('sdf')
        this.uping = true;
        CourseOrderImport(fd)
          .then((res) => {
            console.log(res);
            self.uping = false;
            self.$message.success("上传成功【" + res + "】");
            self.getList();
            // if (res instanceof Array) {
            //     this.selects.push(...res)
            // }
          })
          .catch((err) => {
            self.uping = false;
            self.$message.error("上传出错");
          });
      }
      // console.log(file)
    },
    getTeacher(keyword_search) {
      getTeacherList({ type: 1 }).then((res) => {
        if (res.data instanceof Array) {
          this.teacherList = res.data;
        }
      });
    },
    toDetail(row) {
      console.log(row);
      this.$router.push({
        path: "/course-add",
        query: row,
      });
    },
    toStu(row) {
      console.log(row);
      this.$router.push({
        path: "/course-stu",
        query: row,
      });
    },

    setTop(row) {
      couseTop(row.uuid).then((res) => {
        if (res) {
          this.$message.success("成功");
          this.getList();
        }
      });
    },
    xiajia(row) {
      this.$confirm("确定要" + (row.status == 1 ? "上架" : "下架") + "该课程吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          couseStatus(row.uuid).then((res) => {
            if (res) {
              this.$message.success("成功");
              this.getList();
            }
          });
        })
        .catch(() => {});
    },
    deleteItem(row) {
      this.$confirm("确定要删除该课程吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          delCouse(row.uuid).then((res) => {
            if (res == true) {
              this.$message.success("成功");
              this.getList();
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    async getList(type) {
      if (type == "clear") {
        this.page_index = 1;
      }
      const param = {
        page_index: this.page_index,
        page_size: this.page_size,
        ...this.searchParam,
      };
      this.loading = true;
      const res = await getCouseList(param);
      this.loading = false;
      if (res.data instanceof Array) {
        this.tableData = res.data;
        this.total = res.total;
      }
    },
  },
};
</script>

<style scoped="scoped">
.user-list {
  background: white;
  padding: 10px;
  box-sizing: border-box;
}
</style>
